import { useAuth0 } from '@auth0/auth0-react'
import { LoginButton } from '../buttons/login-button'
import { LogoutButton } from '../buttons/logout-button'
import { SignupButton } from '../buttons/signup-button'
import { ProfileButton } from '../buttons/profile-button'

export const UserNav = () => {
    const { isAuthenticated } = useAuth0()

    return (
        <div className="user-nav-buttons">
            {isAuthenticated ? (
                <div className="button-row-xs-up">
                    <ProfileButton />
                    <LogoutButton />
                </div>
            ) : (
                <div className="button-row-xs-up">
                    <SignupButton />
                    <LoginButton />
                </div>
            )}
        </div>
    )
}
